import React, { FunctionComponent } from 'react';

/**
 * BackArrow Icon
 */
const BackArrowIcon: FunctionComponent<
  React.PropsWithChildren<{
    size: 'small' | 'medium' | 'large';
  }>
> = ({ size }) => {
  switch (size) {
    case 'small':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M11.3334 5.33334H3.22008L6.94675 1.60667L6.00008 0.666672L0.666748 6L6.00008 
            11.3333L6.94008 10.3933L3.22008 6.66667H11.3334V5.33334Z"
            fill="black"
          />
        </svg>
      );
    case 'large':
      return (
        <svg
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.53571 1L2.25 10M2.25 10L9.53571 19M2.25 10H22.1786"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="black" />
        </svg>
      );
  }
};

export default BackArrowIcon;
